<template> 
    <v-dialog v-model="show" :max-width="free ? 375 : 400" overlay-color="#000" overlay-opacity="0.8" :persistent="loading" :fullscreen="phoneOnly && !free" :fluid="phoneOnly && !free" scrollable>
        <v-card class="px-lg-2 pb-1">
            <v-card-title class="mb-2">
                <!-- <v-icon color="secondary" class="me-2">{{'mdi-book-plus-outline'}}</v-icon> -->
                <span>الحصول على الدورة</span>
            </v-card-title>
            <!-- <v-card-subtitle v-if="free">
                <span>أنت على بعد خطوة واحدة من الحصول على الدورة..</span>
            </v-card-subtitle> -->
            <v-card-text v-if="!free" class="strong-text--text pb-0">
                <v-list class="choose-payment-method">
                    <v-list-item v-for="method in paymentMethods" :key="method.value" :class="{'v-list-item--active': paymentMethod === method.value, [`${method.color.split(' ')[0]}--text`]: paymentMethod === method.value}" class="bordered rounded py-1 mb-2" v-ripple="phoneOnly" @click="paymentMethod = method.value">
                        <v-list-item-icon class="me-3">
                            <!-- <v-radio v-model="paymentMethod" :color="method.color || 'primary'" :value="method.value" /> -->
                            <v-btn icon :color="paymentMethod === method.value ? method.color : 'text'">
                                    <svg v-if="paymentMethod === method.value" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z"></path></svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z"></path></svg>
                                
                            </v-btn>

                            <v-icon size="28" :color="method.color || 'primary'" class="ms-1">{{method.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="strong-text--text" style="font-size: 15px">{{method.title}}</v-list-item-title>
                            <v-list-item-subtitle class="details-text" style="line-height: 1.4!important">{{method.subtitle}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <div :class="{'my-4': !!paymentMethod}">
                    <v-expand-transition mode="out-in">
                        <div v-if="paymentMethod === 'wallet'" key="wallet">
                            <div class="mb-2 rounded bordered pa-3 d-flex justify-space-between">
                                <div>
                                    <v-icon color="primary" size="20" class="me-2">mdi-wallet</v-icon>
                                    <span class="details-text strong-text--text">رصيد المحفظة</span>
                                </div>
                                <div>
                                    <v-chip small label outlined :color="noBalance ? 'error' : 'primary'" dark class="ms-3 px-2" style="height: 22px; font-weight: 600;">{{moneyFormat(user.balance, true)}}</v-chip>
                                </div>
                            </div>
                            <div v-if="noBalance" class="text-center pa-3 rounded bordered mb-3">
                                <div class="details-text muted--text mb-2">رصيد محفظتك {{ moneyFormat(user.balance, true) }} غير كافي، لإتمام الشراء ستحتاج لشحن المبلغ التالي:</div>
                                <div class="strong-text--text" style="font-size: 1.5rem">{{moneyFormat(course.price-user.balance)}} <span class="medium-text muted--text">جنيه</span></div>
                            </div>
                            <v-btn v-if="noBalance" class="mb-4" color="primary" depressed block :to="{name: 'wallet', query: {recharge: user.balance ? course.price - user.balance : course.price}}">
                                <v-icon left>mdi-wallet-plus</v-icon>
                                <span>شحن رصيد المحفظة</span>
                            </v-btn>
                            <div v-if="!noBalance" class="text-center pa-3 rounded bordered">
                                <div class="details-text muted--text mb-2">سيتم خصم المبلغ التالي من رصيد محفظتك:</div>
                                <div class="strong-text--text" style="font-size: 1.5rem">{{moneyFormat(course.price)}} <span class="medium-text muted--text">جنيه</span></div>
                                
                            </div>
                        </div>
                        <div v-else-if="paymentMethod === 'paycard'" key="paycard">
                            <div class="mb-4 text-center details-text text--text">
                                أدخل الكود الموجود على بطاقة الدفع:
                            </div>

                            <v-text-field v-model="code" :disabled="loading" prepend-inner-icon="mdi-credit-card-outline" class="code-input" color="secondary" outlined hide-details placeholder="كود بطاقة الدفع"></v-text-field>
                        </div>
                    </v-expand-transition>
                </div>
            </v-card-text>
            <v-card-actions v-if="free">
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" text :disabled="loading" @click="show = false">إلغاء</v-btn>
                <v-btn :color="free ? 'secondary' : 'primary'" :loading="loading" :disabled="loading || (!code && !free)" text @click="purchase">
                    <span v-if="free">الحصول على الدورة</span>
                    <span v-else>إتمام الشراء</span>
                </v-btn>
            </v-card-actions>
            <v-card-actions v-else :class="{'px-6 mt-3': pcOnly}">
                <v-btn icon absolute top left color="white" @click="show = false" class="primary">
                    <v-icon>{{phoneOnly ? 'mdi-chevron-left' : 'mdi-close'}}</v-icon>
                </v-btn>
                
                <v-btn v-if="paymentMethod === 'paycard'" color="success" large :loading="loading" :disabled="loading || !code" block depressed @click="purchase" class="mx-0">
                    إتمام الشراء
                </v-btn>
                <v-btn v-else-if="paymentMethod === 'wallet' && !noBalance" color="primary" large :loading="loading" :disabled="loading || noBalance" block depressed @click="purchase" class="mx-0">
                    إتمام الشراء
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        value: {},
        course: {},
    },
    data(){
        return {
            show: false,
            loading: false,

            code: '',
            paymentMethod: '',
        }
    },
    computed: {
        ...GlobalComputed,
        paymentMethods(){
            let methods = [
                {
                    value: 'paycard',
                    title: 'مجموعات خاصة',
                    subtitle: 'الدفع المباشر بكود بطاقة الدفع الخاص بالمجموعات الخاصة',
                    icon: 'mdi-credit-card-outline',
                    color: 'success darken-1',
                }
            ];
            if (this.appData.enable_wallet_system){
                methods.unshift({
                    value: 'wallet',
                    title: 'محفظة الحساب',
                    subtitle: 'الدفع برصيد محفظة الحساب الخاص بك',
                    icon: 'mdi-wallet-outline',
                    color: 'primary',
                });
            }
            return methods;
        },
        free(){
            return this.course && this.course.free;
        },
        noBalance(){
            if (!this.free){
                const balance = this.user.balance;
                return balance < this.course.price;
            }
            return false;
        }
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        code(code){
            if (code.search(' ') !== -1){
                this.code = code.replace(' ', '');
            }
        },
        value(show){
            this.show = show;
        }
    },
    methods: {
        ...GlobalMethods,
        
        purchase(){
            if ((this.code && this.paymentMethod === 'paycard') || this.free || (!this.noBalance && this.paymentMethod === 'wallet')){
                if (!this.loading){
                    this.loading = true;
                    const id = this.course.id;
                    let data = {}; 
                    if (!this.free){
                        data.pay_by = this.paymentMethod;
                        if (this.paymentMethod === 'paycard'){
                            data.code = this.code;
                        }
                    }
                    this.$store.dispatch('purchaseCourse', {id, data}).then(response=>{
                        this.loading = false;
                        this.show = false;
                        this.showMsg('لقد حصلت على الدورة بنجاح', 'success', false, false, 2000);
                        this.$emit('purchased', response.data.data);
                        this.closeAndNavigate();

                    }).catch(err=>{
                        this.loading = false;
                        if (err && err.response && err.response.data){
                            const msg = err.response.data,
                                status = err.response.status;
                            let reset = true;
                            if (msg === 'LIMIT_EXCEEDED'){
                            this.showMsg('لقد اكتمل عدد الطلاب المسموح به للدورة', 'error');
                            }else if (msg === 'INVALID_PAYCARD_CODE'){
                                this.showMsg('كود بطاقة الدفع غير صحيح', 'error');
                            }else if (msg === 'ALREADY_PURCHASED'){
                                this.showMsg('لقد حصلت على الدورة سابقاً', 'error');
                                this.closeAndNavigate();
                            }else if (msg === 'USED_PAYCARD'){
                                this.showMsg('البطاقة مُستخدمة سابقاً', 'error');
                            }else if (msg === 'EXPIRED_PAYCARD'){
                                this.showMsg('البطاقة منتهية الصلاحية', 'error');
                            }else if (msg === 'PAYCARD_TARGET_VALIDATION_FAILD'){
                                this.showMsg('هذه الدورة لا يمكن شراؤها بالبطاقة المُدخلة', 'error');
                            }else if (msg === 'BALANCE_NOT_ENOUGH'){
                                this.showMsg('رصيد المحفظة غير كافي لإتمام العملية', 'error');

                            }else if (msg && msg.message){
                                this.showMsg(msg.message, 'error');
                            }else{
                                this.showMsg('حدثت مشكلة أثناء تنفيذ طلبك', 'error');
                                reset = false;
                            }
                            if (reset){
                                this.reset();
                            }
                        }else{
                            this.showMsg('حدثت مشكلة أثناء تنفيذ طلبك', 'error');
                        }
                    })
                }
            }else{
                this.showMsg('أدخل كود البطاقة بشكل صحيح', 'error');
            }
        },
        closeAndNavigate(){
            this.show = false;
            if (this.$route.name !== 'course'){
                this.$router.push({name: 'course', params: {id: this.course.id}})
            }
        },
        reset(){
            this.code = '';
        },
    },
    mounted(){
        window.setTimeout(()=>{
            if (this.paymentMethods.length === 1){
                this.paymentMethod = this.paymentMethods[0].value;
            }
        }, 500);
    }
}
</script>

<style lang="scss">
.code-input{
    // hide number input arrows
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }

    input[type=number] {
        -moz-appearance:textfield; /* Firefox */
    }
}
</style>